import React from "react"

import {useKlaraSalesPeopleQuery} from "../../queries/klaraDashboard.ts"
import {getPeriodRange} from "./period.ts"
import {useKlaraPeriod} from "./useKlaraPeriod.ts"

/** The per-person figures of the selected period; the table and the leads person filter share one cached request. */
export const useKlaraSalesPeople = () => {
  const [period] = useKlaraPeriod()
  // The picker computes preset dates on the browser's calendar.
  const range = React.useMemo(() => getPeriodRange(period), [period])

  return useKlaraSalesPeopleQuery(range)
}
